import React, {useState} from 'react';
import {LineDiv, SectionDiv, Text} from "../go-aroung/design";
import useStore from "../Store";

const FloorSelection = ({Floors, selectedHouse, selectedFloor, setSelectedFloor, Data={}}) => {
    function changeFloor(event){
        let Floor=event.currentTarget.id;
        setSelectedFloor(Floor)
    }
    return (

        <SectionDiv
            $visible={Boolean(selectedHouse)}
            $clickable={Boolean(selectedHouse)}
        >
            {Floors.map((floor) => {
                const selected = selectedFloor === floor;

                const hasData = Boolean(
                    selectedHouse &&
                    Data[selectedHouse]?.Floors?.[floor]
                );

                return (
                    <LineDiv
                        key={floor}
                        id={floor}
                        $selected={selected}
                        onClick={changeFloor}
                    >
                        <input
                            type="checkbox"
                            checked={selected}
                            readOnly
                            tabIndex={-1}
                        />

                        <Text>{floor}</Text>

                        {hasData && (
                            <span style={{
                                color: "#019A32",
                                fontWeight: 700
                            }}>
                                +
                            </span>
                        )}
                    </LineDiv>
                );
            })}
        </SectionDiv>
    );
};

export default FloorSelection;